/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

import { CenteredRow } from 'src/styles';

export const CenteredColumn = styled(CenteredRow)({
  flexDirection: 'column',
  textAlign: 'center',
});

export const Code = styled.pre({
  counterReset: 'line',
  backgroundColor: token('elevation.surface.sunken'),
  borderRadius: token('border.radius'),
  font: token('font.body'),
  maxWidth: '100%',
  overflowX: 'auto',
  wordWrap: 'normal',
});

export const CodeLine = styled.div({
  '&::before': {
    backgroundColor: token('elevation.surface.raised.hovered'),
    content: 'counter(line)',
    counterIncrement: 'line',
    display: 'inline-block',
    marginRight: `${gridSize()}px`,
    padding: `${gridSize()}px ${gridSize() * 2}px`,
    textAlign: 'right',
  },
});

export const EmptyStateSection = styled.div({
  margin: `${gridSize() * 6}px 0`,
});

export const ImageContainer = styled.div({
  '> img': {
    width: '100%',
  },
});

export const Instructions = styled.p({
  marginBottom: `${gridSize() * 1.5}px`,
});

export const EmptyStateHeader = styled.h1({
  marginTop: `${gridSize() * 2}px`,
});
